export const CF_TX_GROUP_KEY = 'cf-tx'
